/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetRegisteredUsersReportOptions, GetRegisteredUsersReportResponses } from '../../models/GetRegisteredUsersReport'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Registered Users
 * {@link /reports/registered_users}
 */
export function getRegisteredUsersReport<ThrowOnError extends boolean = true>(options: Options<GetRegisteredUsersReportOptions, ThrowOnError>): Promise<UnwrappedResult<GetRegisteredUsersReportResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/reports/registered_users', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetRegisteredUsersReportResponses, ThrowOnError>>
}
